import * as React from 'react';
import { ErrorCard } from '../components/cards/ErrorCard';

export interface ErrorProps {
    onSubmit: () => void;
    errorTitle: string;
    errorMessage: string;
    errorStates: string;
}

class Error extends React.Component<ErrorProps> {
    render() {
        return (
            <ErrorCard 
                clickEvt={this.props.onSubmit} 
                errorMessage={this.props.errorMessage} 
                errorTitle={this.props.errorTitle}
                errorStatus={this.props.errorStates}                
            />
        );
    }  
    componentWillMount() {
        const logo = document.getElementById('logo') as HTMLElement;
        logo.style.display = 'none';
    }   
}

export default Error;



// WEBPACK FOOTER //
// ./src/error/Error.tsx